import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Portfolio } from "./Menu";
import DropDown from "./DropDown";
import Form from '../Contact/Form';

export default function Header({ variant }) {
    const [isSticky, setIsSticky] = useState(false);
    const [sideHeaderToggle, setSideHeaderToggle] = useState(false);
    const [mobileToggle, setMobileToggle] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
        if (window.scrollY > 0) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
        });
    }, []);

    return (
        <>
        <a href="#main" className="skip-to-main-content-link">Skip to main content</a>
        <div className={`header__area ${ variant ? variant : "" } header__sticky ${isSticky ? "header__sticky-active" : ""}`}>
            <div className="container custom-container">
                <nav className="header__area-box">
                    <div className="header__area-box-logo">
                        <Link to='/'><img src="https://imagedelivery.net/DF926RUMiBgxrQOCj6Rcgg/706e9638-7ca8-4f68-6e16-8d8ac070f600/logo" alt="Wesley Sackenheim" /></Link>
                    </div>
                    <div className="header__area-box-main-menu one">
                        <ul className="mobile__menu" role="navigation" style={{ display: `${mobileToggle ? "block" : "none"}` }}>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/about">About</Link>
                            </li>
                            <li className="menu-item-has-children">
                                <Link to="" aria-haspopup="true" aria-expanded="false">Portfolio</Link>
                                <DropDown>
                                    <ul className="sub-menu">
                                    <Portfolio />                        
                                    </ul>
                                </DropDown>
                            </li>
                            <li>
                                <Link to="/News">News</Link>
                            </li>

                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                        <span className={mobileToggle ? "mobile-menu mobile-menu-active" : "mobile-menu"} onClick={() => setMobileToggle(!mobileToggle)}>
                            <span></span>
                        </span>
                    </div>
                    <div className="header__area-box-sidebar">
                        <div className="header__area-box-sidebar-popup-icon"> 
                            <span onClick={() => setSideHeaderToggle(!sideHeaderToggle)}><i className="fal fa-bars" tabIndex="0" role="button" aria-label="sidebar button"></i></span> 
                        </div>
                    </div>
                    <div className={sideHeaderToggle ? 'header__area-box-sidebar-popup active' : 'header__area-box-sidebar-popup'}>
                        <div className="sidebar-close-btn one" onClick={() => setSideHeaderToggle(!sideHeaderToggle)}> <i className="fal fa-times" tabIndex="0" aria-label="button to access contact form" role="button"></i> </div>
                        <div className="header__area-box-sidebar-popup-logo">
                            <Link to='/'><img src="https://imagedelivery.net/DF926RUMiBgxrQOCj6Rcgg/706e9638-7ca8-4f68-6e16-8d8ac070f600/logo" alt="Wesley Sackenheim" /></Link>
                        </div>
                        <div className="header__area-box-sidebar-popup-contact">
                            <h4 className="mb-25">Get in touch</h4>
                            <Form></Form>
                        </div>
                        
                    </div>
                    <div className={sideHeaderToggle ? 'sidebar-overlay show' : 'sidebar-overlay'}></div> 
                </nav>
            </div>
        </div>
        </>
    );
}
